module.exports = __webpack_public_path__ + "img/full-logo-300w.6b0b7458.png";